import logo from "./logo.svg";
import "./App.css";
import HomePage from "./page/HomePage";
import "./css/Navbar.css";
import "./css/home/HomeSlider.css";
import "./css/Footer.css";
import "./css/ShowGiftBox.css";
import "./css/ShowGiftBox.css";
import "./css/GiftBoxMainPage.css";
import "./css/BoxDetailsGift.css"
import "./css/home/HomeGiftBoxComponent.css"
import "./css/CartList.css"
import "./css/home/HomeTestimonials.css"
import "./css/home/HomeCustomerWalls.css"
import "./css/auth/LoginPage.css"
import "./css/others/Others.css"
import "./css/ProfilePage.css"
import"./css/CheckBookingForm.css"
import "./css/ThanksPage.css"




import { BrowserRouter, Routes, Route } from "react-router-dom";
import BoxDetailGift from "./page/BoxDetailGift";
import TopNav from "./component/common/TopNav";
import Navbar from "./component/common/Navbar";
import GiftBoxMainPage from "./page/GiftBoxMainPage";
import Footer from "./component/common/Footer";
import JaipurisetPage from "./page/JaipurisetPage";
import CartList from "./component/common/CartList";
import ChokerSetsPage from "./page/ChokerSetsPage";
import EARRINGSPage from "./page/EARRINGSPage";
import BraceletsPage from "./page/BraceletsPage";
import RingsPage from "./page/RingsPage";
import NoseRingsPage from "./page/NoseRingsPage";
import AnkletsPage from "./page/AnkletsPage";
import BanglesPage from "./page/BanglesPage";
import ScrollToTop from "./component/others/TopToScroll";
import LoginPage from "./component/auth/LoginPage";
import ProfilePage from "./component/common/ProfilePage";

import ProtectedRoute from "./component/auth/ProtectedRoute"
import PublicRoute from "./component/auth/PublicRoute";
import CheckBookingForm from "./component/common/CheckBookingForm";
import ThanksPage from "./component/common/ThanksPage";







function App() {
  return (
    // <BrowserRouter>
<>
     <ScrollToTop/>

      <div>
        <TopNav />
        <Navbar />
      </div>
    
      <Routes>
        <Route path="/" element={<HomePage />}>
       
        </Route>
        {/* <Route path="/product/:id" element={<BoxDetailGift />} /> */}

         <Route path="/product/:id" element={<BoxDetailGift />} />
         <Route path="/collection/giftbox" element={<GiftBoxMainPage  categoryType="Gift Boxes" />}></Route>
         <Route path="/collection/jaiputiset" element={<JaipurisetPage  categoryType="Jaipuri Sets" />}></Route>
         <Route path="/collection/chokersets" element={<ChokerSetsPage  categoryType="Choker Sets" />}></Route>
         <Route path="/collection/ear-rings"  element={<EARRINGSPage  categoryType="EARRINGS" />}></Route>
          <Route path="/collection/bracelets" element={<BraceletsPage  categoryType="Bracelets" />}></Route>
          <Route path="/collection/rings"     element={<RingsPage  categoryType="Rings" />}></Route>
          <Route path="/collection/nose-rings" element={<NoseRingsPage  categoryType="Noise Rings" />}></Route>
          <Route  path="/collection/anklets"   element={<AnkletsPage  categoryType="Anklets" />}></Route>
          <Route path="/collection/bangles"     element={<BanglesPage  categoryType="Bangles" />}></Route>


          <Route path="/thanks-booking" element={<ThanksPage/>} ></Route>

          <Route   path="/login"element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }/>



         <Route path="/auth/profile"  element ={
           <ProtectedRoute>
          <ProfilePage/>
          </ProtectedRoute>
          } />

      </Routes>

      <Footer />
      </>

  );
}

export default App;
